<section class="flex-column">
  <div class="container">
    <div class="our_project_header " #textContent>
      <h2 class="text-center mssg_1" #textContent>ZUMERA PROJECTS</h2>
      <h2 class="welcome_mssg mssg_2 text-center" #textContent>Creating products and environments of the highest standard, offering innovation and exceptional value for you.</h2>
    </div>
    
  </div>  
  
</section>

<section class="project_pages">
  
  <div class="section section_2">
    <div class="overlay"></div>
    <div class="project_desc position-absolute cl-light z-3 d-flex flex-column ">
      <h2 class="project_name" #textContent>THE ELITES RESIDENCE</h2>
      <h4 class="project_tag_line" #textContent>Greatness, Now has an Address</h4>
      <a class="know-more-btn align-self-start " routerLink="/projects/Elites-Residence" #textContent>KNOW MORE <span class="ps-2 "> &#8594;</span></a>
    </div>
  </div>
</section>

<section class="project_pages">
  <div class="section section_3">
    <div class="overlay"></div>
    <div class="project_desc position-absolute cl-light z-3 d-flex flex-column ">
      <h2 class="project_name" #textContent>QUEEN IDIA RESIDENCE</h2>
      <h4 class="project_tag_line" #textContent>The Neighbourhood for the Brave</h4>
      <a class="know-more-btn align-self-start " routerLink="/projects/Queen-Idia" #textContent>KNOW MORE <span class="ps-2 "> &#8594;</span></a>
    </div>
  </div>
</section>